'use client';

import { useEffect } from 'react';
import { captureBoundaryError } from '@/lib/captureError';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Report the render error to PostHog (no-op for internal/uninitialized).
    // Sanitizes circular refs so posthog-js doesn't report a bogus circular-JSON
    // TypeError in place of the real error — see lib/captureError.ts.
    captureBoundaryError(error);
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      <h2 className="mb-4 text-3xl font-medium text-gray-800">Something went wrong</h2>
      <p className="mb-8 max-w-md text-gray-500">
        We encountered an unexpected error. Please try again or return to the homepage.
      </p>
      <button
        onClick={reset}
        className="rounded-md bg-red-600 px-6 py-3 text-sm font-bold uppercase text-white transition-colors hover:bg-red-700"
      >
        Try Again
      </button>
    </div>
  );
}
